import{ensureInitialized as n}from"../internal/internalAPIs.js";import{runtime as r}from"./runtime.js";function e(){var e;return null!==(e=n(r)&&r.isNAAChannelRecommended)&&void 0!==e&&e}export{e as isNAAChannelRecommended};
